import { faBadgeCheck, faBuildingUser, faUser } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Avatar, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { isTabletScreen } from "ui/tools/responsive"
import {
  FIRST_SIGNUP_WIZARD_STEP,
  getAllSignUpWizardSteps,
  SECOND_SIGNUP_WIZARD_STEP,
  SIGNUP_WIZARD_STEPS
} from "user/model"
import { canGoToSignupStep, goToSignUpStep } from "user/tools/signup"

interface ISignUpWizardProgressHeaderProps {
  activeStep: SIGNUP_WIZARD_STEPS
  isTablet: boolean
}

export const SignUpWizardProgressHeaderFn = React.memo(({ activeStep }: ISignUpWizardProgressHeaderProps) => {
  return (
    <FlexBox
      jc="space-evenly"
      sx={{
        "width": "100%",
        "height": "5rem",
        "maxHeight": "5rem",
        "mt": "1rem",
        "& .icon": { color: theme => theme.palette.background.default, transition: "all 500ms ease" },
        "& .icon.active": { color: theme => theme.palette.primary.main },
        "& .line.active": { backgroundColor: theme => theme.palette.primary.main }
      }}>
      {getAllSignUpWizardSteps().map(toDisplayStep => {
        const isAvailable = activeStep >= toDisplayStep
        const isActive = activeStep === toDisplayStep
        const canGoToStep = canGoToSignupStep(toDisplayStep)
        return (
          <FlexBox
            key={toDisplayStep}
            sx={{
              position: "relative",
              width: "33.4%"
            }}>
            <FlexBox
              sx={{
                position: "absolute",
                top: "2.5rem",
                width: "100%",
                height: ".2rem",
                backgroundColor: theme => theme.palette.secondary.main,
                transition: "background-color 500ms ease"
              }}
              className={`line${isAvailable ? " active" : ""}`}
            />
            <FlexBox
              vertical
              key={toDisplayStep}
              onClick={isAvailable && canGoToStep ? () => goToSignUpStep(toDisplayStep) : undefined}
              sx={isAvailable && canGoToStep ? { "&:hover": { cursor: "pointer" } } : undefined}>
              <Avatar
                sx={{
                  zIndex: 1,
                  width: "4rem",
                  height: "4rem",
                  bordercolor: theme => theme.palette.primary.main,
                  bgcolor: theme => theme.palette.background.paper
                }}>
                <FontAwesomeIcon
                  icon={
                    toDisplayStep === FIRST_SIGNUP_WIZARD_STEP
                      ? faUser
                      : toDisplayStep === SECOND_SIGNUP_WIZARD_STEP
                        ? faBuildingUser
                        : faBadgeCheck
                  }
                  className={`icon${isAvailable ? " active" : ""}`}
                />
              </Avatar>
              <Typography
                fontSize="1rem"
                fontWeight={isActive ? 500 : undefined}
                color={isActive ? "textPrimary" : "textSecondary"}
                sx={{ transition: "all 500ms ease" }}>
                {translate(`user.signup.title.${toDisplayStep}`)}
              </Typography>
            </FlexBox>
          </FlexBox>
        )
      })}
    </FlexBox>
  )
})

export const SignUpWizardProgressHeader = connect(
  (state: IRootState): ISignUpWizardProgressHeaderProps => ({
    isTablet: isTabletScreen(state),
    activeStep: state.user.signup.step
  })
)(SignUpWizardProgressHeaderFn)
